import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { formatTimestamp } from "../../lib";
import { decorateJob } from "./_helpers";

export const job_by_id: Query<Ctx> = async ({ sb }, params) => {
  const id = params.get("id");
  if (!id) return null;

  const { data } = await sb
    .from("v_jobs_list")
    .select("*")
    .eq("id", id)
    .single();
  if (!data) return null;

  const job_claim = data.claim_id
    ? {
        id: data.claim_id,
        job_opening_id: data.id,
        user_id: data.claim_user_id,
        status: data.claim_status,
        claimed_at: data.claim_claimed_at,
        cancelled_at: data.claim_cancelled_at,
        created_at: data.claim_created_at,
        updated_at: data.claim_updated_at,
        school: [{ label: data.school_name, value: data.school_id }],
        profile: data.claim_user_id
          ? { label: data.claimed_by, value: data.claim_user_id }
          : null,
        f_claimed_at: formatTimestamp(data.claim_claimed_at),
        f_cancelled_at: formatTimestamp(data.claim_cancelled_at),
        f_created_at: formatTimestamp(data.claim_created_at),
        f_updated_at: formatTimestamp(data.claim_updated_at),
      }
    : null;

  return { ...decorateJob(data), job_claim };
};
